/**
 * @desc 查询委托方看到的出价列表
 */
import { BidRecordEntity } from '@eastcoal/api/trade/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type QueryEntrustBidRecordListParameter = {
  id?: string
}

const method = 'GET'
const url = '/trade/member/bidRecord/list/entrust'

export const queryEntrustBidRecordListApi = (
  params?: QueryEntrustBidRecordListParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<Array<BidRecordEntity>>({
    method,
    url,
    params,
    ...config
  })
}

queryEntrustBidRecordListApi.method = method
queryEntrustBidRecordListApi.url = url
